/* global google */

export default {
  init() {
    // JavaScript to be fired on the contact page
	
		var wrapper1 = $('.wrapper-contact-1'),
			wrapper2 = $('.wrapper-contact-2'),
			seeTeam = 'see-team';
		wrapper1.waypoint(function () {
			wrapper1.addClass(seeTeam);
			this.destroy();
		}, {
			offset: '40%'
		});

		wrapper2.waypoint(function () {
			wrapper2.addClass(seeTeam);
			this.destroy();
		}, {
			offset: '35%'
		});



		var initMap = function () {
			var usRoadMapType = new google.maps.StyledMapType([
				{
					"featureType": "all",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"saturation": 36
						},
						{
							"color": "#000000"
						},
						{
							"lightness": 40
						}
					]
				},
				{
					"featureType": "all",
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"visibility": "on"
						},
						{
							"color": "#000000"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"featureType": "all",
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "administrative",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 17
						},
						{
							"weight": 1.2
						}
					]
				},
				{
					"featureType": "landscape",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 20
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 21
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.fill",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 17
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry.stroke",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 29
						},
						{
							"weight": 0.2
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 18
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 16
						}
					]
				},
				{
					"featureType": "transit",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 19
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#000000"
						},
						{
							"lightness": 17
						}
					]
				}
			], {name: 'mm style'});
			var uluru = {lat: 52.161017, lng: 21.027842};
 

//map 2
			var map = new google.maps.Map(document.getElementById('map'), {
                disableDefaultUI: true,
                zoomControl:true,
                scrollwheel: false,
				zoom: 13,
				center: uluru,
				zoomControlOptions: {
					position: google.maps.ControlPosition.LEFT_TOP
				}
			});
			map.mapTypes.set('mmWarszawa', usRoadMapType);
			map.setMapTypeId('mmWarszawa');
			var contentString = '<div class="map-info-box">' + '<div class="map-head">' + '</div>';

			new google.maps.InfoWindow({
				content: contentString
			});
			
			var marker = new google.maps.Marker({
				position: uluru,
				map: map,
				icon: '/wp-content/themes/mintmedia/dist/images/marker.png'
			});

			marker.addListener('click', function () {
				var win = window.open('https://www.google.pl/maps/dir//Mint+Media+Sp.+z+o.o.,+Puławska+465,+02-844+Warszawa/@52.1371305,21.0181472,18z','_blank');
				win.focus();
				
//				map.setZoom(10);
//				map.setCenter(marker.getPosition());
//				console.log('popup');
				return false;
			});
		}

		$(window).on("load", function() {
			initMap();
            
            
		});

		window.onorientationchange = function () {
			window.location.reload();
		};

  }
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js